import { PrjTitle, PrjGif, PrjCol, PrjFeature, PrjList } from "../../../../src/data/projects/mdxComponents";
import * as React from 'react';
export default {
  PrjTitle,
  PrjGif,
  PrjCol,
  PrjFeature,
  PrjList,
  React
};